import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Logo } from 'components/atoms';
import { SidebarToggleButton } from 'components/atoms';
import { SidebarHeaderProps } from 'types/components.types';
import { LOGO_USAGE, LOGO_ALT_TEXT } from 'constants/logo.constants';

const SidebarHeader: React.FC<SidebarHeaderProps> = ({
  onToggle,
  isCollapsed = false,
  className = ''
}) => {
  const navigate = useNavigate();

  return (
    <div className={`px-4 py-2 flex items-center ${isCollapsed ? 'justify-center' : 'justify-between'} h-[72px] ${className}`}>
      {!isCollapsed && (
        <button onClick={() => navigate('/')} className="cursor-pointer inline-flex items-center">
          <Logo
            variant={LOGO_USAGE.SIDEBAR.variant as 'full' | 'long' | 'icon'}
            size="md"
            alt={LOGO_ALT_TEXT.LONG}
          />
        </button>
      )}
      <SidebarToggleButton onClick={onToggle} isCollapsed={isCollapsed} />
    </div>
  );
};

export default SidebarHeader;
